<template>
    <ZTruck></ZTruck>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const ZTruck = defineAsyncComponent(() =>
    import("../../components/Logistics/ZTruck.vue")
);
export default {
    name: "Logistics_ZTruck", //The name you are in should not equal the name of the component you are importing.
    components: { ZTruck, AuthLayout },
};
</script>